import React, { Component } from "react";
import { Input, Select } from "../widgets";

const TICKET_STATUS_OPTIONS = ["Open", "Resolved"].map(option => {
  return { value: option, label: option };
});

const TICKET_PRIORITY_OPTIONS = ["High", "Normal", "Low"].map(option => {
  return { value: option, label: option };
});

class SupportIssuesSearch extends Component {
  render() {
    return (
      <>
        <Input
          placeholder="Subject or address..."
          onChange={e => this.props.onFilterFieldChange("subjectOrAddress", e.target.value)}
          value={this.props.subjectOrAddress ? this.props.subjectOrAddress : ""}
          containerStyle={{ flex: 5 }}
          style={{ width: "100%" }}
        />
        <Select
          placeholder="Ticket Status..."
          value={this.props.ticketStatus}
          options={TICKET_STATUS_OPTIONS}
          onChange={value =>
            this.props.onFilterFieldChange("ticketStatus", value ? value.value : null)
          }
          containerStyle={{ flex: 2 }}
          style={{ flex: "100%" }}
        />
        <Select
          placeholder="Ticket Priority..."
          value={this.props.ticketPriority}
          options={TICKET_PRIORITY_OPTIONS}
          onChange={value =>
            this.props.onFilterFieldChange("ticketPriority", value ? value.value : null)
          }
          containerStyle={{ flex: 2 }}
          style={{ flex: "100%" }}
        />
      </>
    );
  }
}

export default SupportIssuesSearch;
